/**
 * B3612 — Cruzamento de Médias BIAS.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.B3612). Painel próprio, 2 linhas, SEM parâmetros (as janelas 3/6/12 são
 * fixas no engine — a classe não tem `AddParam`):
 *
 *   B36  = MA(C,3) − MA(C,6)
 *   B612 = MA(C,6) − MA(C,12)
 *
 * Paridade provada em __tests__/b3612.silverlight.test.js.
 */
import { ma, sub } from "./silverlightDsl";

// Janelas fixas no engine (a fórmula não expõe parâmetros).
const N_SHORT = 3;
const N_MID = 6;
const N_LONG = 12;

export default function () {
  let options = {};

  function calculator(data) {
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );
    const ma3 = ma(close, N_SHORT);
    const ma6 = ma(close, N_MID);
    const ma12 = ma(close, N_LONG);

    const b36 = sub(ma3, ma6);
    const b612 = sub(ma6, ma12);

    return b36.map((v, i) => {
      const b36Out = Number.isFinite(v) ? v : undefined;
      const b612Out = Number.isFinite(b612[i]) ? b612[i] : undefined;
      if (b36Out === undefined && b612Out === undefined) return undefined;
      return { b36: b36Out, b612: b612Out };
    });
  }

  calculator.undefinedLength = function () {
    return N_LONG - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...x };
    return calculator;
  };

  return calculator;
}
